class NSSNostalgiaMallMap extends HTMLElement {

  constructor() {
    super();

    this.debug = false;

    this.modalEl = this.querySelector(`.nss-nostalgia-mall-map__modal`);
  }

  connectedCallback() {
    if (this.debug) console.log("[NSS][Nostalgia Mall Map] Connected.");

    const mapEl = this.querySelector(`[nss-nostalgia-map]`);
    const overlayEl = this.querySelector(`[nss-nostalgia-overlay]`);
    mapEl.addEventListener(`scroll`, (e) => {
      overlayEl.scrollLeft = mapEl.scrollLeft;
    });

    const pointEls = this.querySelectorAll(`nss-nostalgia-mall-map-item`);
    pointEls.forEach((pointEl) => {
      pointEl.addEventListener(`click`, this.showModal.bind(this));
    });

    this.modalEl.addEventListener(`click`, this.hideModal.bind(this));
  }

  showModal(e) {
    this.hideAllModalItems();
    const modalId = e.target.getAttribute(`nss-map-modal`);
    const modalItemEl = this.modalEl.querySelector(`[nss-map-modal="${modalId}"]`);
    modalItemEl.classList.add(`nss-active`);
    this.modalEl.classList.add(`nss-active`);
  }

  hideAllModalItems() {
    const modalItemEls = this.querySelectorAll(`.nss-nostalgia-mall-map__modal-item`);
    modalItemEls.forEach((modalItemEl) => {
      modalItemEl.classList.remove(`nss-active`);
    });
  }

  hideModal() {
    this.modalEl.classList.remove(`nss-active`);
    this.hideAllModalItems();
  }
}

let elementName = `nss-nostalgia-mall-map`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSNostalgiaMallMap);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`)
}